import "./Footer.css";

export default function Footer() {
  return (
    <div className="footer">
      <p>Bookez</p>
      <p>© Aarya Kasbe</p>
    </div>
  );
}
